import React from "react";
import eyeIcon from "@public/img/eye.svg";
import { Link } from "react-router-dom";
type RowHeaderProps = {
  title: string;
  actionLabel: string;
  actionLink: string;
};

export default function RowHeader({
  title,
  actionLabel = "مشاهده همه",
  actionLink,
}: RowHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-4" dir="rtl">
      <h2 className="text-2xl font-bold leading-normal text-slate-100">{title}</h2>

      <Link to={actionLink}
        target="_blank"
        className="flex h-10 items-center gap-1.5 rounded-lg border border-zinc-700/80 bg-[#1f201d] px-3 text-sm font-medium text-zinc-300 transition-colors hover:border-zinc-500 hover:bg-[#272824] hover:text-slate-100"
      >
        <span>{actionLabel}</span>
        <img src={eyeIcon} alt="" />
      </Link>
    </div>
  );
}
